<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import {
		resolveFlowNodeTypeLabel,
		resolveScheduleConditionSummary,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: summary = resolveScheduleConditionSummary(data);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('scheduleCondition', data);
</script>

<BaseConditionNode
	{id}
	type="scheduleCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={summary}
	{nodeTypeLabel}
	{...$$restProps}
/>
